import { useState, useEffect } from "react";
import "./Sidebar.styles.scss";
import { SidebarElement } from "src/router/types/sidebar";
import SidebarUI from "./Sidebar.presenter";
import { useRouter } from "src/hooks/useRouter";
import { useCheckIsRenew } from "src/hooks/validation/useCheckIsRenew";

interface ISidebar {
  sidebarContent?: SidebarElement[];
}
const Sidebar = ({ sidebarContent }: ISidebar) => {
  // API 호출
  const [path, setPath] = useState<string>("console");

  // // recoil 전역 상태
  const { isRenew } = useCheckIsRenew({});
  const route = useRouter();

  useEffect(() => {
    const currentPath = route.currentPath.split("/");
    setPath(currentPath[currentPath.length - 1]);
    // console.log("currentPath", currentPath[currentPath.length - 1]);
  }, [route.currentPath]);
  return (
    <>
      <SidebarUI
        path={path}
        goConsole={route.goConsole}
        goBill={route.goBill}
      />
    </>
  );
};

export default Sidebar;
